import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { contactInfo } from '@/mocks/homeData';

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
    fbq: (action: string, eventName: string, params?: Record<string, unknown>) => void;
  }
}

export default function ContatoRecebidoPage() {
  useEffect(() => {
    window.scrollTo(0, 0);

    // --- GTM: evento de conversão de formulário ---
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'form_submission',
        conversionType: 'lead',
        formName: 'cta_avaliacao',
        pageLocation: '/contato-recebido',
      });
    } catch { /* GTM não carregado */ }

    // --- Meta Pixel: evento Lead ---
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', {
          content_name: 'Formulário de Avaliação',
          content_category: 'Conversão',
        });
      }
    } catch { /* Pixel não carregado */ }
  }, []);

  return (
    <main className="min-h-screen bg-background-50 flex flex-col">
      <div className="flex-1 flex items-center justify-center px-4 md:px-6 py-16 md:py-24">
        <div className="max-w-lg w-full text-center">
          <div className="w-20 h-20 md:w-24 md:h-24 mx-auto mb-8 rounded-full bg-accent-100 flex items-center justify-center">
            <i className="ri-check-line text-accent-600 text-3xl md:text-4xl"></i>
          </div>

          <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3 leading-tight">
            Contato recebido!
          </h1>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-10">
            Sua solicitação foi enviada com sucesso para a Dra. Marihana Pasquali. Nossa equipe retorna em até <strong className="text-foreground-950">15 minutos</strong> durante o horário comercial.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-10">
            <div className="bg-background-100 rounded-xl p-4">
              <div className="w-9 h-9 mx-auto mb-2 rounded-lg bg-accent-50 flex items-center justify-center">
                <i className="ri-time-line text-accent-600 text-base"></i>
              </div>
              <p className="text-xs text-foreground-600 leading-relaxed">
                Resposta em até <strong className="text-foreground-950">15 minutos</strong>
              </p>
            </div>
            <div className="bg-background-100 rounded-xl p-4">
              <div className="w-9 h-9 mx-auto mb-2 rounded-lg bg-accent-50 flex items-center justify-center">
                <i className="ri-whatsapp-line text-accent-600 text-base"></i>
              </div>
              <p className="text-xs text-foreground-600 leading-relaxed">
                Retornaremos pelo <strong className="text-foreground-950">WhatsApp</strong>
              </p>
            </div>
            <div className="bg-background-100 rounded-xl p-4">
              <div className="w-9 h-9 mx-auto mb-2 rounded-lg bg-accent-50 flex items-center justify-center">
                <i className="ri-shield-check-line text-accent-600 text-base"></i>
              </div>
              <p className="text-xs text-foreground-600 leading-relaxed">
                Seus dados estão <strong className="text-foreground-950">protegidos</strong>
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center mb-10">
            <Link
              to="/"
              className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold px-8 py-3.5 rounded-full transition-all duration-300 cursor-pointer text-center"
            >
              <i className="ri-home-4-line mr-2"></i>
              Voltar ao site
            </Link>
            <a
              href={`https://wa.me/${contactInfo.whatsapp}?text=Olá!%20Acabei%20de%20enviar%20o%20formulário%20de%20contato%20e%20gostaria%20de%20confirmar%20o%20recebimento.`}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="whitespace-nowrap border border-foreground-200 hover:border-accent-400 text-foreground-700 text-sm font-medium px-8 py-3.5 rounded-full transition-all duration-300 cursor-pointer text-center"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              Falar no WhatsApp agora
            </a>
          </div>

          <p className="text-xs text-foreground-400">
            Horário de atendimento: segunda a sexta, 8h às 19h | sábado, 8h às 13h
          </p>
        </div>
      </div>

      <footer className="py-6 border-t border-background-200">
        <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
          <p className="text-xs text-foreground-400">
            Dra. Marihana Pasquali — CRO-SP 172094 | Av. Brigadeiro Faria Lima, 2355 — 6º andar — São Paulo
          </p>
        </div>
      </footer>
    </main>
  );
}